"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.default = function () {};


//////////////////
// WEBPACK FOOTER
// ./~/react-cursor-position/dist/utils/noop.js
// module id = 269
// module chunks = 35783957827783